import PropTypes from "prop-types";
import moment from 'moment';
import { FaSquare, FaTrash } from 'react-icons/fa';

TabellaFerie.propTypes = {
    ferie: PropTypes.array,
    edit: PropTypes.func,
    openDelete: PropTypes.func
}

function TabellaFerie({ferie, edit, openDelete}) {

    const buildDescrizione = (object, index) => {
        var descrizione = "";
        if(object.tipo === "FERIE") {
            const inizio = moment(object.inizio).format("DD/MM/YYYY");            
            const fine = moment(object.fine).add(-1,'days').format("DD/MM/YYYY");
            descrizione = inizio + " - " + fine;
        } else if (object.tipo === "PERMESSO") {
            const giorno =  moment.utc(object.inizio).local().format("DD/MM/YYYY");
            const oraInizio = moment.utc(object.inizio).local().format("HH:mm");
            const oraFine = moment.utc(object.fine).local().format("HH:mm");
            descrizione = giorno + " dalle " + oraInizio + " alle: " + oraFine;
        }
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        return <a className="link" id={`edit-${index}`} onClick={()=> edit(object)}>{descrizione}</a>;
    }
    
    return (<div>

        <div className='legenda'>
            <FaSquare className='boxLegendaFerie'></FaSquare> <span>ferie  </span> <FaSquare className='boxLegendaPermesso'></FaSquare> <span>permesso</span>
        </div>
        <table className="table table-bordered space bordiSpessi" id="tabellaferie">
            <tbody>
                {ferie.length !==0 && ferie.map((object, index) => {
                    return <tr key={`ferie-${object.id}`} id={`ferie-${index}`} className={`${object.tipo.toLowerCase()}`}>
                        <td className="inEvidenza bordiSpessi">{buildDescrizione(object, index)}
                            {openDelete(<span id={`elimina-ferie-${index}`} className="deleteIcon"><FaTrash title='elimina ferie/permessi' /></span>, object)}</td>                        
                    </tr>
                }
                )}
            </tbody>
        </table>
    </div>)
}

export default TabellaFerie;